<template>
  <div id="entry">
    <span class="title">扫码查真伪</span>
    <div class="vin-input-wrap">
      <input
        class="vin-input"
        type="text"
        placeholder="请输入17位车架号或VIN码"
        maxlength="17"
        bindinput="onInputVinCode"
        v-model.trim="vinCode"
      />
      <div class="vin-input-right">
        <span>({{ vinCode.length }}/17)</span>
        <!-- <img class="icon" :src="$IMG_BASE_URL + '/final/1_14.png'" @click="scanVinCode" /> -->
      </div>
    </div>

    <div class="input-tip">请输入17位VIN码</div>

    <div class="tip">
      <div class="title">注意事项</div>
      <span
        >感谢您选择购买{{
          $store.state.encodeInfo.zhangtao
        }}产品，为了保障您的合法消费权益，正确激活产品质保，请如实填写以上必填内容。</span
      >
    </div>

    <my-button class="bottom-btn" @click.native="toActivation">下一步</my-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      vinCode: ''
    }
  },
  methods: {
    scanVinCode() {},
    toActivation() {
      if (!this.vinCode) return this.$toast('vin码不能为空')
      if (this.vinCode.length !== 17) return this.$toast('vin码位数需为17位')
      this.$router.push('/activation?vinCode=' + this.vinCode)
    }
  }
}
</script>

<style scoped lang="less">
#entry {
  padding: 50px;
  font-size: 12px;

  .title {
    font-weight: bold;
    font-size: 18px;
  }

  .vin-input-wrap {
    position: relative;
    margin-top: 30px;
    padding: 4px;
    border: 1px solid #f5f5f5;

    .vin-input {
      width: 100%;
      height: 35px;
      padding: 0 50px 0 10px;
      text-align: left;
      background-color: #f5f5f5;
    }

    .vin-input-right {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 12px;
      color: @THEME_COLOR;

      // .icon {
      //   padding: 10px;
      //   width: 36px;
      //   height: 36px;
      // }
    }
  }

  .input-tip {
    margin: 10px 0 50px 0;
    color: #999;
  }

  .tip {
    line-height: 20px;
    color: #999;

    .title {
      margin-bottom: 5px;
      font-weight: bold;
      font-size: 15px;
      color: #000;
    }
  }

  .bottom-btn {
    width: 100%;
    margin-top: 160px;
  }
}
</style>
